import React, { FC, HTMLAttributeAnchorTarget, JSX } from 'react';
import { Link } from 'react-router-dom';
//import { useTranslation } from 'react-i18next';
import styles from './Anchor.module.css';

export enum AnchorMode {
    primary = 'primary',
    secondary = 'secondary',
    light = 'light',
    danger = 'danger',
    link = 'link',
    none = '',
}

export interface AnchorProps {
    id?: string;
    classes?: string;
    href?: string;
    mailTo?: string;
    tel?: string;
    children: JSX.Element | JSX.Element[] | string;
    icon?: string;
    iconPosition?: 'left' | 'farLeft';
    mode: AnchorMode;
    size?: 'sm' | 'md';
    outline?: boolean;
    disabled?: boolean;
    textColor?: 'light'; // may be used with mode 'secondary'
    bgColor?: 'blue' | 'black'; // may be used with mode 'primary'
    tall?: boolean; // may be used with small buttons
    target?: HTMLAttributeAnchorTarget;
    rel?: string;
    onClick?: (e: React.MouseEvent) => void;
}

const AnchorComponent: FC<AnchorProps> = ({
    id,
    classes,
    href,
    mailTo,
    tel,
    children,
    icon,
    iconPosition,
    mode,
    size,
    outline,
    disabled,
    textColor,
    bgColor,
    tall,
    target,
    rel,
    onClick,
}) => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    // const { i18n } = useTranslation();

    const commonClasses =
        // mode + outline
        `${mode !== AnchorMode.none ? `btn ${styles.btn} ${styles[`btn-${outline ? 'outline-' : ''}${mode}`]}` : styles.basic}` +
        // size
        ` ${size === 'sm' ? ` btn-sm ${styles['btn-sm']} ${tall ? styles['btn-sm-tall'] : ''}` : ''}` +
        // override text color
        ` ${textColor === 'light' ? styles['btn-text-light'] : ''}` +
        // override bg color
        ` ${bgColor === 'blue' ? styles['btn-bg-blue'] : ''}` +
        ` ${bgColor === 'black' ? styles['btn-bg-black'] : ''}` +
        // override icon position
        ` ${iconPosition === 'farLeft' ? styles['far-left-icon'] : ''}` +
        // extra classes
        ` ${classes || ''}` +
        ` ${disabled ? styles['disabled'] : ''}`;

    // const link = mailTo
    //     ? `mailto:${mailTo}`
    //     : tel
    //       ? `tel:${tel}`
    //       : href?.startsWith('http')
    //         ? href
    //         : `/${i18n.language === (i18n.options?.fallbackLng || '') ? href : `${i18n.language}/${href}`}`;

    const link = mailTo ? `mailto:${mailTo}` : tel ? `tel:${tel}` : href?.startsWith('http') ? href : `/${href}`;

    const handleClick = (e: React.MouseEvent) => {
        if (disabled) {
            e.preventDefault();
            e.stopPropagation();
        } else {
            onClick && onClick(e);
        }
    };

    return (
        <Link
            to={link}
            id={id || undefined}
            className={commonClasses}
            onClick={handleClick}
            target={target}
            rel={rel}
            data-testid="anchor">
            {icon && <i className={icon} />} {children}
        </Link>
    );
};

export const Anchor = AnchorComponent;
